import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach the browser's local date (YYYY-MM-DD) to every request so backend
// forecast logic stays aligned with the user's calendar day rather than the
// server's UTC clock. This prevents "tomorrow's" pay period from showing as
// current when a US user hits the API late in their local evening.
function localDateISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

api.interceptors.request.use((config) => {
  config.params = { client_date: localDateISO(), ...(config.params || {}) };
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(n) {
  if (n == null || Number.isNaN(Number(n))) return "$0.00";
  const v = Number(n);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso + (iso.length <= 10 ? "T00:00:00" : ""));
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso + (iso.length <= 10 ? "T00:00:00" : ""));
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

// Compact date-range formatter: drops the year from the start date when
// both dates fall in the same calendar year. Ex.
//   formatDateRange("2026-07-31", "2026-08-13") → "Jul 31 – Aug 13, 2026"
//   formatDateRange("2025-12-28", "2026-01-10") → "Dec 28, 2025 – Jan 10, 2026"
export function formatDateRange(startIso, endIso) {
  if (!startIso || !endIso) return "—";
  const s = new Date(startIso + (startIso.length <= 10 ? "T00:00:00" : ""));
  const e = new Date(endIso + (endIso.length <= 10 ? "T00:00:00" : ""));
  const sameYear = s.getFullYear() === e.getFullYear();
  const start = sameYear ? formatDateShort(startIso) : formatDate(startIso);
  const end = formatDate(endIso);
  return `${start} – ${end}`;
}
